var _g, _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1638_9351)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C2.44772 0 2 0.447716 2 1V23C2 23.5523 2.44772 24 3 24H21C21.5523 24 22 23.5523 22 23V4L18 0H3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0V4H22L18 0Z",
    fill: "#C2CDDE"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 10,
    width: 22,
    height: 10,
    rx: 1,
    fill: "#4881F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.01527 18V12.1818H6.19709C6.64406 12.1818 7.01906 12.2652 7.32209 12.4318C7.62701 12.5985 7.85713 12.8277 8.01243 13.1193C8.16963 13.4091 8.24822 13.7386 8.24822 14.108C8.24822 14.4811 8.16963 14.8125 8.01243 15.1023C7.85523 15.392 7.62322 15.6203 7.31641 15.7869C7.00959 15.9517 6.63175 16.0341 6.18288 16.0341H4.73686V15.1676H6.04084C6.3022 15.1676 6.51622 15.1222 6.68288 15.0312C6.84955 14.9403 6.97266 14.8153 7.0522 14.6562C7.13364 14.4972 7.17436 14.3144 7.17436 14.108C7.17436 13.9015 7.13364 13.7197 7.0522 13.5625C6.97266 13.4053 6.8486 13.2831 6.68004 13.196C6.51338 13.107 6.29841 13.0625 6.03516 13.0625H5.06925V18H4.01527ZM13.945 12.1818V18H13.0075L10.266 14.0369H10.2177V18H9.16371V12.1818H10.1069L12.8455 16.1477H12.8967V12.1818H13.945ZM18.9911 14.0398C18.9438 13.8864 18.8784 13.7491 18.7951 13.6278C18.7137 13.5047 18.6152 13.3996 18.4996 13.3125C18.386 13.2254 18.2553 13.16 18.1076 13.1165C17.9599 13.071 17.7989 13.0483 17.6246 13.0483C17.3121 13.0483 17.0337 13.1269 16.7894 13.2841C16.5451 13.4413 16.3529 13.6723 16.2127 13.9773C16.0745 14.2803 16.0053 14.6496 16.0053 15.0852C16.0053 15.5246 16.0745 15.8968 16.2127 16.2017C16.351 16.5066 16.5432 16.7386 16.7894 16.8977C17.0356 17.0549 17.3216 17.1335 17.6474 17.1335C17.9428 17.1335 18.1985 17.0767 18.4144 16.9631C18.6322 16.8494 18.7998 16.6884 18.9173 16.4801C19.0347 16.2699 19.0934 16.0237 19.0934 15.7415L19.332 15.7784H17.7525V14.9545H20.1133V15.6534C20.1133 16.1515 20.0072 16.5824 19.7951 16.946C19.583 17.3097 19.2913 17.59 18.9201 17.7869C18.5489 17.982 18.1228 18.0795 17.6417 18.0795C17.1057 18.0795 16.6351 17.9593 16.2298 17.7188C15.8263 17.4763 15.511 17.1326 15.2837 16.6875C15.0584 16.2405 14.9457 15.7102 14.9457 15.0966C14.9457 14.6269 15.012 14.2074 15.1445 13.8381C15.279 13.4688 15.4665 13.1553 15.707 12.8977C15.9476 12.6383 16.2298 12.4413 16.5536 12.3068C16.8775 12.1705 17.2298 12.1023 17.6104 12.1023C17.9324 12.1023 18.2326 12.1496 18.511 12.2443C18.7894 12.3371 19.0366 12.4697 19.2525 12.642C19.4703 12.8144 19.6493 13.0189 19.7894 13.2557C19.9296 13.4924 20.0214 13.7538 20.065 14.0398H18.9911Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1638_9351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 24,
    fill: "white",
    transform: "translate(2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/png.bb9ed1bd5b46ca3d3db01f313bb4fb32.svg";
export { ForwardRef as ReactComponent };